export default __webpack_public_path__ + "static/media/vc.f9f3c253.svg";